module.exports = __webpack_public_path__ + "static/WelcomeToElk0-e3b31990d2a3f952b1cb556d7ee2c6a8.png";